import {doc, getDoc, collection, setDoc,updateDoc, serverTimestamp, arrayUnion, arrayRemove} from "firebase/firestore";
import {getFirebase} from "../config/firebase.config";

const {firestore} = getFirebase();
const empPath = "employees";
const empDb = collection(firestore, empPath);

const getAll = () => {
    return empDb;
};
const getDocById = (docId) => {
    return getDoc(doc(firestore, empPath, docId));
}
const getEmpId = (docId) => {
    getDoc(doc(firestore, empPath, docId)).then((docSnap) => {
        if (docSnap.exists()) {
            return {id: docSnap.id, ...docSnap.data()}
        } else {
            return null;
        }
    });
}
const createOrUpdate = (docId, data) => {
    const empDocRef = doc(firestore, empPath, docId);
    data.createdAt = serverTimestamp();
    return setDoc(empDocRef, data, {merge: true});
};
const create = (data) => {
    return empDb.add(data);
};
const update = (id, value) => {
    return empDb.doc(id).update(value);
};
const remove = (id) => {
    return empDb.doc(id).delete();
};

const updateClients = (docId, data) => {
    const empDocRef = doc(firestore, empPath, docId);
    return updateDoc(empDocRef, {clients: arrayUnion(data.consumerName)});
}

const deleteClient = (docId, data) => {
    const empDocRef = doc(firestore, empPath, docId);
    return updateDoc(empDocRef, {clients: arrayRemove(data)});
}

const EmployeeService = {
    getAll,
    getDocById,
    getEmpId,
    createOrUpdate,
    create,
    update,
    remove,
    updateClients,
    deleteClient
}
export default EmployeeService;

